/* eslint-disable @typescript-eslint/no-unused-vars */

import List from '@mui/material/List'
import Box from '@mui/material/Box'
import {
  createTheme,
  responsiveFontSizes,
  ThemeProvider,
} from '@mui/material/styles'
import themeConfig from 'src/theme/themeConfig'
import Drawer from './Drawer'
import VerticalNavItems from './VerticalNavItems'
import VerticalNavHeader from './VerticalNavHeader'
import themeOptions from 'src/theme/ThemeOptions'

const Navigation = () => {
  //@ts-ignore
  let darkTheme = createTheme(themeOptions({}, 'dark'))

  if (themeConfig.responsiveFontSizes) {
    darkTheme = responsiveFontSizes(darkTheme)
  }

  return (
    <ThemeProvider theme={darkTheme}>
      <Box
        className="scrollbar-hidden"
        sx={{
          position: 'relative',
          height: '100dvh',
          overflow: 'hidden',
          maxHeight: '100dvh',
        }}
      >
        <Drawer>
          <VerticalNavHeader />

          <List
            className="scrollbar-hidden nav-items"
            sx={{
              flex: 1,
              minHeight: 0,
              pt: 0,
              pb: { xs: 3, md: 6 },
              px: 2,
              mt: 6,
              overflowY: 'auto',
              overflowX: 'hidden',
              overscrollBehavior: 'contain',
              WebkitOverflowScrolling: 'touch',
              scrollbarGutter: 'stable',
              '& > :first-child': { mt: '0' },
            }}
          >
            <VerticalNavItems />
          </List>
        </Drawer>
      </Box>
    </ThemeProvider>
  )
}

export default Navigation
